import React from 'react';
import { Link } from 'react-router-dom';
import FluxPromptTitleLogo from '../../assets/icons/FluxPromptTitle.svg?url';

type Props = {
  children: React.ReactNode;
  title?: string;
  className?: string;
};

const FluxLogoDark = () => (
  <div className="auth-logo">
    <img src={FluxPromptTitleLogo} style={{ height: 14 }} alt="FluxPrompt" />
  </div>
);

const AuthCard = ({ children, className }: Props) => {
  return (
    <div className={`auth-card${className ? ` ${className}` : ''}`}>
      <div className="auth-card__header">
        <FluxLogoDark />
      </div>
      <div className="auth-card__body">{children}</div>
      <div className="auth-card__footer">
        <div className="auth-card__footer-links">
          <Link to="/legal/terms-of-service">Terms of Service</Link>
          <Link to="/legal/privacy-policy">Privacy Policy</Link>
        </div>
        <p className="auth-card__disclaimer" style={{ paddingTop: 16 }}>Background image generated from daily news</p>
      </div>
    </div>
  );
};

export default AuthCard;
